import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { OnboardingCardId } from '@trellis/shared'

import { dismissOnboardingCard } from '@/requests/users'

export function useDismissOnboardingCardMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (cardId: OnboardingCardId) => {
      const result = await dismissOnboardingCard(cardId)
      if (result.error) throw new Error(result.error.message)
      return result
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['onboarding-status'] })
    },
  })
}
